import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createCapacidad } from '../api/capacidadFuncionalApi';

const calcularEquilibrio = (piesJuntos, semitandem, tandem) => {
  let pts = 0;
  if (parseFloat(piesJuntos) >= 10) pts += 1;
  if (parseFloat(semitandem) >= 10) pts += 1;
  const t = parseFloat(tandem);
  if (t >= 3 && t <= 9.99) pts += 1;
  else if (t >= 10) pts += 2;
  return pts;
};

const calcularDesplazamiento = (tiempo) => {
  const t = parseFloat(tiempo);
  if (!t) return 0;
  if (t > 8.7) return 1;
  if (t >= 6.21) return 2;
  if (t >= 4.82) return 3;
  return 4;
};

const calcularFuerza = (tiempo) => {
  const t = parseFloat(tiempo);
  if (!t) return 0;
  if (t > 16.7) return 1;
  if (t >= 13.7) return 2;
  if (t >= 11.2) return 3;
  return 4;
};

export const useCapacidadFuncionalForm = ({ idPaciente }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    tiempoPiesJuntos: '',
    tiempoSemitandem: '',
    tiempoTandem: '',
    tiempoDesplazamiento: '',
    tiempoSentadillas: '',
    tiempoTUG: '',
    falloEjecucion: false,
  });
  const [openGood, setOpenGood] = useState(false);
  const [openError, setOpenError] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const parsedValue =
      type !== 'checkbox' && typeof value === 'string' ? value.replace(/,/g, '.') : value;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : parsedValue,
    }));
  };

  const velocidadMarcha = useMemo(
    () =>
      formData.tiempoDesplazamiento
        ? (4 / parseFloat(formData.tiempoDesplazamiento)).toFixed(2)
        : '',
    [formData.tiempoDesplazamiento]
  );

  const sppbTotal = useMemo(
    () =>
      calcularEquilibrio(
        formData.tiempoPiesJuntos,
        formData.tiempoSemitandem,
        formData.tiempoTandem
      ) +
      calcularDesplazamiento(formData.tiempoDesplazamiento) +
      calcularFuerza(formData.tiempoSentadillas),
    [
      formData.tiempoPiesJuntos,
      formData.tiempoSemitandem,
      formData.tiempoTandem,
      formData.tiempoDesplazamiento,
      formData.tiempoSentadillas,
    ]
  );

  const esFragilTUG = formData.tiempoTUG && parseFloat(formData.tiempoTUG) >= 12;

  const guardarDatos = async () => {
    try {
      await createCapacidad({
        pacienteId: idPaciente.toString(),
        userId: localStorage.getItem('id'),
        payload: { ...formData, velocidadMarcha, sppbTotal },
      });
      setOpenGood(true);
      setTimeout(() => navigate(`/paciente/${idPaciente}`), 1500);
    } catch (error) {
      console.error('Error al guardar capacidad funcional:', error);
      setOpenError(true);
    }
  };

  return {
    formData,
    velocidadMarcha,
    sppbTotal,
    esFragilTUG,
    openGood,
    openError,
    setOpenGood,
    setOpenError,
    handleChange,
    guardarDatos,
  };
};
